exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "  #quotation-template {\r\n     background: white;\r\n     padding: 24px;\r\n  /* display: block;\r\n  margin: 0 auto;\r\n  margin-bottom: 0.5cm;\r\n  box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);\r\n  width: 21cm;\r\n  height: 29.7cm;   */\r\n} \r\n@media print {\r\n  body, #quotation-template {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-shadow: 0;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/quotation/quotation-history-single/quotation-history-single.component.css
// module id = ../../../../../src/app/components/quotation/quotation-history-single/quotation-history-single.component.css
// module chunks = 0